import React from 'react';
import { MenuItemModel } from '@components/layout/menu/types.ts';
import { useLocalStorage } from 'primereact/hooks';
import MenuItem from '@components/layout/menu/MenuItem.tsx';

interface ComponentProps {
  smallMenu?: boolean;
  lockedMenu?: boolean;
  menu: MenuItemModel[];
  localStorageKey: string;
}

const Menu: React.FC<ComponentProps> = ({ smallMenu, menu, lockedMenu, localStorageKey }) => {
  const [openedMenus, setOpenedMenus] = useLocalStorage<number[]>([], localStorageKey);

  const toggleOpenMenu = (index: number) => {
    if (openedMenus.includes(index)) {
      setOpenedMenus(openedMenus.filter(i => i !== index));
    } else {
      setOpenedMenus([...openedMenus, index]);
    }
  };

  return (
    <>
      <ul className={''}>
        {menu
          .filter(t => t.render)
          .map((item, index) => {
            return (
              <MenuItem
                render={item.render}
                key={index}
                title={item.title}
                icon={item.icon}
                subMenu={item.subMenu}
                mode={item.mode}
                smallMenu={smallMenu && !lockedMenu}
                url={item.url}
                elementCount={0}
                isOpen={openedMenus.includes(index)}
                onClick={() => {
                  toggleOpenMenu(index);
                }}
              />
            );
          })}
      </ul>
    </>
  );
};

export default Menu;
